import { createFeatureSelector } from '@ngrx/store';
import { State } from './app.reducers';

export const feature = 'app451';

export const selectApp = createFeatureSelector<State>(feature);
